import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer>
            <div className="footer-section">
                <h3>Prawne</h3>
                <p><Link to="/privacy" className="router-link">Polityka prywatności</Link></p>
                <p><Link to="/terms" className="router-link">Warunki świadczenia usług</Link></p>
            </div>
            <div className="footer-section">
                <h3>Kontakt</h3>
                <p><a href="mailto:kontakt@kaloai.pl">kontakt@kaloai.pl</a></p>
            </div>
            <div className="footer-section">
                <h3>Informacje</h3>
                <p>© 2024 KaloAI</p>
            </div>
        </footer>
    );
};

export default Footer;